import React from "react";

import { Button } from "@newsela/angelou";
import {
  actionPrefixes,
  objectTypes,
  actionNames,
  withTrackEvent,
} from "@newsela/snitch";

import PropTypes from "prop-types";

import AddIcon from "@/icons/AddIcon";
import WarningIcon from "@/icons/WarningIcon";
import AssigneesList from "../AssigneesList/AssigneesList";
import { addIconCss } from "../AssignmentEditor.style";
import {
  assigneeManagementButtonsCss,
  iconSizeCss,
  selectAssigneesInfoText,
  SGAassignmentEditorAssigneesLabelCss,
} from "./AssigneeSelector.style";

const propTypes = {
  hasAssignees: PropTypes.bool,
  classroomSelectorSetActive: PropTypes.func,
  createClassroomSetActive: PropTypes.func,
  createClassroomTriggerRef: PropTypes.any,
  currentSelectionOfClassrooms: PropTypes.array,
  currentSelectionOfStudentAssignees: PropTypes.array,
  determineSmallGroupName: PropTypes.func,
  renderAssigneeModal: PropTypes.func,
  setCurrentSelectionOfClassrooms: PropTypes.func,
  showWarningIcon: PropTypes.bool,
  assigneeSelectorModalTriggerRef: PropTypes.any,
  showCreateClass: PropTypes.bool,
};

const ButtonWithTrackEvent = withTrackEvent(Button);

const AssigneeSelector = ({
  hasAssignees,
  createClassroomSetActive,
  createClassroomTriggerRef,
  currentSelectionOfClassrooms,
  currentSelectionOfStudentAssignees,
  determineSmallGroupName,
  renderAssigneeModal,
  setCurrentSelectionOfClassrooms,
  showWarningIcon,
  assigneeSelectorModalTriggerRef,
  showCreateClass,
}) => {
  return (
    <div>
      <div css={SGAassignmentEditorAssigneesLabelCss}>Assignees</div>
      {hasAssignees ? (
        <AssigneesList
          currentSelectionOfClassrooms={currentSelectionOfClassrooms}
          currentSelectionOfStudentAssignees={
            currentSelectionOfStudentAssignees
          }
          setCurrentSelectionOfClassrooms={setCurrentSelectionOfClassrooms}
          determineSmallGroupName={determineSmallGroupName}
        />
      ) : (
        <div css={selectAssigneesInfoText}>
          {showWarningIcon ? <WarningIcon css={iconSizeCss} /> : null}
          Select assignees to send the assignment to individuals, a small group,
          or entire classes.
        </div>
      )}
      <div css={assigneeManagementButtonsCss}>
        <Button
          flavor={Button.flavors.secondary}
          onClick={renderAssigneeModal}
          ref={assigneeSelectorModalTriggerRef}
          __cssFor={{ root: { fontWeight: "700" } }}
        >
          <AddIcon css={addIconCss} />
          {`${hasAssignees ? "Add/edit" : "Select"} assignees`}
        </Button>
        {showCreateClass && (
          <ButtonWithTrackEvent
            flavor={Button.flavors.tertiary}
            __cssFor={{ root: { fontWeight: "700" } }}
            ref={createClassroomTriggerRef}
            onClick={() => {
              createClassroomSetActive(true);
            }}
            objectType={objectTypes.classroom}
            actionPrefix={actionPrefixes.initiate}
            actionName={actionNames.create}
            streamProperties={{
              description: "Create a new class",
            }}
          >
            Create new class
          </ButtonWithTrackEvent>
        )}
      </div>
    </div>
  );
};

AssigneeSelector.propTypes = propTypes;

export default AssigneeSelector;
